export const CORE_ACTIONS_KEYS = {
  calculateCorePosition: 'getCorePosition',
  callAddToWishlistClientEvent: 'addToWishlistClientEvent',
  callRemoveFromWishlistClientEvent: 'removeFromWishlistClientEvent',
  callGetWishlistClientEvent: 'callGetWishlistClientEvent',
  mapWishlistToExistingResults: 'mapWishlistToExistingResults',
  setInputQuery: 'setInputQuery'
} as const;

export const CORE_MUTATIONS_KEYS = {
  addToWishlist: 'addToWishlist',
  mapWishlistToExistingResults: 'mapWishlistToExistingResults',
  removeFromWishlist: 'removeFromWishlist',
  setUserAcceptedQuery: 'setUserAcceptedQuery',
  setCoreStyles: 'setCoreStyles',
  setDirtyInput: 'setDirtyInput',
  setHasTabbed: 'setHasTabbed',
  setHorizontalScrollType: 'setHorizontalScrollType',
  setInputQuery: 'setInputQuery',
  setOpen: 'setOpen',
  setOpenEmpathize: 'setOpenEmpathize',
  setOpenFinished: 'setOpenFinished',
  setOpenSortList: 'setOpenSortList',
  setScrollDirection: 'setScrollDirection',
  setScrollEnabled: 'setScrollEnabled',
  setScrollOffset: 'setScrollOffset',
  setFirstGridItemIdInView: 'setFirstGridItemIdInView',
  setWishlist: 'setWishlist',
  toggleOpenSortList: 'toggleOpenSortList',
  stateLoadedFromCache: 'stateLoadedFromCache'
} as const;
